export default function setCommonFieldsForCurrentUser({ state }) {
  let { registrating, currentUser } = state.get('client')
  if (currentUser) {
    let common = registrating.current.common
    Object.keys(common).forEach(field => {
      if (currentUser[field]) {
        state.merge(`client.registrating.current.common.${field}`, {
          value: currentUser[field]
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/actions/setCommonFieldsForCurrentUser.js